import { useState } from 'react';
import { Turnstile } from './Turnstile';
import { publicApi } from '../lib/api';

export function BrandInquiry() {
  const [form, setForm] = useState({ name: '', email: '', company: '', budget_range: '', message: '' });
  const [token, setToken] = useState<string | null>(null);
  const [state, setState] = useState<'idle' | 'sending' | 'done' | 'error'>('idle');
  const [err, setErr] = useState('');

  const set = (k: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    setForm((f) => ({ ...f, [k]: e.target.value }));

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!token) { setErr('Please complete the verification.'); return; }
    setState('sending'); setErr('');
    try {
      await publicApi.brandInquiry({ ...form, turnstileToken: token });
      setState('done');
    } catch (e: any) {
      setState('error'); setErr(e?.message || 'Something went wrong.');
    }
  }

  if (state === 'done') {
    return (
      <div className="ln-inq-done">
        <div className="ln-badge"><span className="ln-dot" /> received</div>
        <h3>Got it. We will be in touch.</h3>
        <p className="ln-sub">We reply to brand inquiries within one business day.</p>
      </div>
    );
  }

  return (
    <form className="ln-inq-form" onSubmit={submit}>
      <input className="ln-input" placeholder="Your name" value={form.name} onChange={set('name')} required />
      <input className="ln-input" placeholder="Work email" type="email" value={form.email} onChange={set('email')} required />
      <input className="ln-input" placeholder="Company" value={form.company} onChange={set('company')} />
      <input className="ln-input" placeholder="Monthly budget (optional)" value={form.budget_range} onChange={set('budget_range')} />
      <textarea className="ln-input" placeholder="What do you want clipped?" value={form.message} onChange={set('message')} rows={3} />
      <Turnstile onVerify={setToken} onExpire={() => setToken(null)} theme="dark" />
      {err && <p className="ln-inq-err">{err}</p>}
      <button className="ln-btn-primary" type="submit" disabled={state === 'sending'}>
        {state === 'sending' ? 'Sending...' : 'Book a demo'}
      </button>
    </form>
  );
}
